export const RESULT_LIST_ITEM_ID_PREFIX = 'rx-results-list-item';
export const RESULTS_LIST_SELECTOR = '.e2e-results-list';
export const RESULT_REFERENCE_TARGETS = Object.freeze({
  DOCUMENT: 'document',
  REACTION: 'reaction',
});

const NO_FOCUS_RING_CLASS = 's-els-no-focus';

export function getResultListItemId(position) {
  return `${RESULT_LIST_ITEM_ID_PREFIX}-${position}`;
}

export function focusResultsList({ preventScroll = false } = {}) {
  const resultsList = document.querySelector(RESULTS_LIST_SELECTOR);
  resultsList?.focus({ preventScroll });
  return !!resultsList;
}

export function getResultListItemByResultId(resultId) {
  if (resultId === undefined || resultId === null) {
    return null;
  }

  return (
    Array.from(document.querySelectorAll('.results-content .e2e-results-list-item[data-result-id]')).find(
      (element) => element.getAttribute('data-result-id') === String(resultId)
    ) || null
  );
}

export function getResultReferenceTargetByResultId(resultId, targetType) {
  const resultListItem = getResultListItemByResultId(resultId);
  return resultListItem?.querySelector(`[data-summary-reference-target="${targetType}"]`) || null;
}

function getScrollBehavior() {
  return window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches ? 'auto' : 'smooth';
}

export function scrollResultListItemIntoView(resultElement) {
  if (!resultElement) {
    return false;
  }

  resultElement.scrollIntoView?.({
    behavior: getScrollBehavior(),
    block: 'start',
    inline: 'nearest',
  });
  return true;
}

export function focusAndScrollReferenceTarget(referenceTarget, { block = 'start' } = {}) {
  if (!referenceTarget) {
    return false;
  }

  // A reference jump moves focus away from the clicked marker, so its destination must stay visible
  // even when Leyden's GlobalFocusToggle has put the page in pointer-input mode.
  document.body?.classList?.remove(NO_FOCUS_RING_CLASS);
  referenceTarget.focus?.({ preventScroll: true });
  referenceTarget.scrollIntoView?.({
    behavior: getScrollBehavior(),
    block,
    inline: 'nearest',
  });
  return true;
}
